import { amtStr, amtStr4Dec } from 'helpers/StringNumberFunction/numFormatter';
import { dateFormat } from '../../../helpers/StringNumberFunction/formatDate';
import { ELetterServiceClient } from './service/ELetterServiceClient';
import { ELetterServicePurchase } from './service/ELetterServicePurchase';
import { ELetterServiceSubcon } from './service/ELetterServiceSubcon';
import { ELetterServiceSubcontract } from './service/ELetterServiceSubcontract';
import { ELetterServiceSupplier } from './service/ELetterServiceSupplier';

const moduleParams = (
  accountType: string,
  docType: string,
  previewDetail,
  allpreviewDetail,
  getCompany,
  getCustomer,
  getSubcontract,
  page,
  pageLength,
  submittedByLedger,
  ItemIndex,
) => {
  let logoUrl = getCompany[0]?.ImageUrl;

  let paramVal: any = {
    '[companyLogo]': getCompany[0]?.ImageUrl
      ? `<img style="max-height: 100px; max-width: 100px; padding:2px;"
                 src="${getCompany[0]?.ImageUrl}"
                 width="151" height="97"
                 crossorigin="anonymous">`
      : `<img style="max-height: 100px; max-width: 100px; padding:2px;"
                 src="https://static.vecteezy.com/system/resources/previews/004/141/669/non_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg"
                 width="151" height="97"
                 crossorigin="anonymous">`,
    '[companyName]': getCompany[0]?.Name!,
    '[companyRegNo]': getCompany[0]?.CompanyRegNo!,
    '[companyTinNo]': getCompany[0]?.Tin!,
    '[companyAddress]': `${getCompany[0]?.Address?.address}
  <br />
  ${
    getCompany[0]?.Address?.country == 'Singapore'
      ? `${getCompany[0]?.Address?.country} ${getCompany[0]?.Address?.postCode}`
      : `${getCompany[0]?.Address?.postCode} ${getCompany[0]?.Address?.city}, ${getCompany[0]?.Address?.state}, ${getCompany[0]?.Address?.country}`
  }`,
    '[companySstNo]': getCompany[0]?.SSTNo ? getCompany[0]?.SSTNo : '',
    '[companyGstNo]': getCompany[0]?.GSTNo ? getCompany[0]?.GSTNo : '',
    '[companyContactNo]': getCompany[0]?.ContactNo!,
    '[beneficiaryName]': getCompany[0]?.Name!,
    '[msicCode]': getCompany[0]?.assignedMsic?.[0]?.msicCode,
    '[PageNo]': previewDetail?.PageNo || previewDetail?.pageNumber || page + 1,
    '[TotalPage]':
      previewDetail?.TotalPage || previewDetail?.totalPages || pageLength,
    '[CreatedBy]': previewDetail?.auditLog?.createdName,
    '[CreatedDate]': dateFormat(previewDetail?.createdTs!),
    '[ModifiedBy]': previewDetail?.auditLog?.modName,
    '[ModifiedDate]': dateFormat(previewDetail?.modTs!),
    '[preparedBy]': submittedByLedger,
  };

  if (!!previewDetail?.ApprovalWorkflow) {
    const latestWF = previewDetail?.ApprovalWorkflow.filter(
      workflow => workflow?.WorkFlowStatus === 'COMPLETED',
    );

    latestWF[0]?.WorkflowStep?.filter(
      x => x?.ApprovalStatus === 'APPROVED',
    )?.map((el, i) => {
      const index = i + 1;
      paramVal[`[ApprovedBy${index}]`] = !!el?.Name ? el?.Name : '';
      paramVal[`[ApprovedDate${index}]`] = !!el?.ApprovalDT
        ? dateFormat(el?.ApprovalDT)
        : '';
    });
  }

  switch (accountType) {
    case 'client-account':
      ELetterServiceClient({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        getCompany,
        getCustomer,
        ItemIndex,
      });
      break;
    case 'subcontractor-account':
      ELetterServiceSubcon({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        ItemIndex,
      });
      break;
    case 'supplier-account':
      ELetterServiceSupplier({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        ItemIndex,
      });
      break;
    case 'project-purchase':
      ELetterServicePurchase({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        ItemIndex,
      });
      break;
    case 'subcontract':
      ELetterServiceSubcontract({
        docType,
        previewDetail,
        allpreviewDetail,
        getSubcontract,
        paramVal,
        ItemIndex,
      });
      break;
  }

  return paramVal ?? {};
};

export const groupItemDataForPreview = ({
  templateBody,
  groupKeys,
  dataItem,
}) => {
  let parser = new DOMParser();
  let doc = parser.parseFromString(templateBody, 'text/html');
  let element = doc.getElementById('ItemValue');
  const regex = /\[(.*?)\]/g;
  const matches = [];
  let match;

  while ((match = regex.exec(element.innerHTML)) !== null) {
    matches.push(match[1]);
  }

  const filteredArr = matches.filter(value => groupKeys.includes(value));

  const groupedData = dataItem.reduce((acc, item) => {
    const key = filteredArr.map(k => item[`${k}`]).join('-');

    if (!acc[key]) {
      acc[key] = { ...item };
    } else {
      acc[key].Quantity += item.Quantity;
      acc[key].BaseAmt += item.BaseAmt;
      acc[key].TaxAmt += item.TaxAmt;
      acc[key].TotalAmt += item.TotalAmt;
    }

    return acc;
  }, {});

  // Convert the result back to an array
  return Object.values(groupedData) ?? [];
};

export const groupItemData = (
  element,
  arrItem,
  Itemindex,
  threshold,
  groupKeys,
  sumValueKeys,
) => {
  const regex = /\[(.*?)\]/g;
  const matches = [];
  let match;

  while ((match = regex.exec(element.innerHTML)) !== null) {
    matches.push(match[1]);
  }

  const filteredArr = matches.filter(value => groupKeys.includes(value));

  const groupedItems: any[] = arrItem.reduce((acc, item) => {
    const key = filteredArr.map(k => item[`[${k}]`]).join('-');

    if (!acc[key]) {
      acc[key] = filteredArr.reduce(
        (obj, k) => {
          obj[`[${k}]`] = item[`[${k}]`];
          return obj;
        },
        {
          '[Quantity]': 0,
          '[TaxAmt]': 0,
          '[TotalAmt]': 0,
          '[BaseAmt]': 0,
        },
      );
    }

    sumValueKeys?.map(x => {
      acc[key][`[${x?.column}]`] += parseFloat(
        item[`[${x?.column}]`].replace(/,/g, ''),
      );
    });

    return acc;
  }, {});

  const result = Object.values(groupedItems)
    .filter((x, i) => i >= Itemindex && i + 1 <= Itemindex + 15)
    .map((item, index) => {
      let obj = {
        '[Index]': index + 1,
        '[GlobalIndex]': index + 1 + Itemindex,
        ...item,
      };
      sumValueKeys?.map(el => {
        obj[`[${el?.column}]`] =
          el?.decimal === 4
            ? amtStr4Dec(item[`[${el?.column}]`])
            : amtStr(item[`[${el?.column}]`]);
      });
      return obj;
    });
};

export const extractItemValue = (htmlString, arrItem) => {
  let parser = new DOMParser();
  let doc = parser.parseFromString(htmlString, 'text/html');
  let element = doc.getElementById('ItemValue');
  let ItemData = arrItem;

  // function to replace AllocatedItemValue data
  const replaceAllocatedItemValue = (itemhtml, obj) => {
    var keys = Object.keys(obj)
      .map(key => key.replace(/[\[\]]/g, '\\$&'))
      .join('|');
    var regex = new RegExp(keys, 'gi');

    return itemhtml.replace(regex, function(matched) {
      return obj[matched];
    });
  };

  // function to replace ItemValue data
  const replaceItemValue = (itemhtml, obj) => {
    var keys = Object.keys(obj)
      .map(key => key.replace(/[\[\]]/g, '\\$&'))
      .join('|');
    var regex = new RegExp(keys, 'gi');

    const DebitAlloc = obj?.subItem ?? [];
    let itemdoc = parser.parseFromString(itemhtml, 'text/html');
    let AllocatedItemValue = itemdoc.getElementById('AllocatedItemValue');

    // Condition if have AllocatedItemValue element
    if (AllocatedItemValue) {
      // Replace value for AllocatedItemValue if DebitAlloc have data
      if (DebitAlloc?.length > 0) {
        const alloccontainer = DebitAlloc.map(x =>
          replaceAllocatedItemValue(AllocatedItemValue.innerHTML, x),
        ).join(' ');

        AllocatedItemValue.innerHTML = alloccontainer;
      } else {
        // Remove AllocatedItemValue if DebitAlloc does not have data
        AllocatedItemValue.parentNode.removeChild(AllocatedItemValue);
      }

      return itemdoc.documentElement.outerHTML.replace(regex, function(
        matched,
      ) {
        return obj[matched];
      });
    } else {
      return itemhtml.replace(regex, function(matched) {
        return obj[matched];
      });
    }
  };

  if (element && ItemData && ItemData?.length > 0) {
    const container = ItemData.map(x =>
      replaceItemValue(element.innerHTML, x),
    ).join(' ');

    element.innerHTML = container;

    return doc.documentElement.outerHTML;
  }

  return htmlString;
};

export const extractAllocItemValue = (htmlString, arrItem) => {
  let parser = new DOMParser();
  let doc = parser.parseFromString(htmlString, 'text/html');
  let element = doc.getElementById('AllocItemValue');
  let ItemData = arrItem;

  const replaceItemValue = (itemhtml, obj) => {
    var keys = Object.keys(obj)
      .map(key => key.replace(/[\[\]]/g, '\\$&'))
      .join('|');
    var regex = new RegExp(keys, 'gi');

    return itemhtml.replace(regex, function(matched) {
      return obj[matched];
    });
  };

  if (element && ItemData && ItemData?.length > 0) {
    const container = ItemData.map(x =>
      replaceItemValue(element.innerHTML, x),
    ).join(' ');

    element.innerHTML = container;

    return doc.documentElement.outerHTML;
  }

  return htmlString;
};

export const extractHtmlValue = (
  htmlTemplate,
  accountType,
  docType,
  previewDetail,
  allpreviewDetail,
  getCompany,
  getCustomer,
  getSubcontract,
  page,
  pageLength,
  submittedByLedger,
  threshold: any,
) => {
  const Itemindex = threshold * page;

  var mapObj: any = moduleParams(
    accountType,
    docType,
    previewDetail,
    allpreviewDetail,
    getCompany,
    getCustomer,
    getSubcontract,
    page,
    pageLength,
    submittedByLedger,
    Itemindex,
  );

  var keys = Object.keys(mapObj)
    .map(key => key.replace(/[\[\]]/g, '\\$&'))
    .join('|');
  var regex = new RegExp(keys, 'gi');

  let htmlContent = htmlTemplate;
  if (!!htmlTemplate) {
    htmlContent = htmlTemplate
      .replace(regex, function(matched) {
        return mapObj[matched];
      })
      .replace(/border-top: 1px dotted #ccc;/g, '')
      .replace(/border-bottom: 1px dotted #ccc;/g, '');

    if (mapObj?.items?.length > 0) {
      htmlContent = extractItemValue(htmlContent, mapObj?.items);
    }
    if (mapObj?.allocItems?.length > 0) {
      htmlContent = extractAllocItemValue(htmlContent, mapObj?.allocItems);
    }
    htmlContent = htmlContent.replace(/\[.*?\]/g, '');
  }

  return htmlContent;
};
